<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div
      class="mt-5 d-flex justify-content-center"
      style="margin-top: 8% !important"
    >
      <div class="barras d-flex" style="width: 50%">
        <b-form-input
          @keydown.enter.native="obtenerDocumentosCertificadosAcuerdoServicio()"
          class="input-filter"
          v-model="filtro.palabraClave"
          placeholder="Búsqueda de documentos por nombre"
          type="text"
        >
        </b-form-input>
        <b-button
          class="btn_busqueda"
          variant="info"
          @click="obtenerDocumentosCertificadosAcuerdoServicio()"
        >
          <div
            class="d-flex justify-content-center align-items-center"
            style="height: 100%"
          >
            <em class="buscar_svg" style="margin-top: 3px; height: 0.8em"> </em>
          </div>
        </b-button>
      </div>

      <b-button
        v-if="$localStorageService.can('PAS_01_portal_aut_emisi_agreg')"
        variant="primary"
        v-b-tooltip.hover
        title="Agregar nuevo documento"
        class="paddingbotones botonesAzulFuerteRedondo d-flex justify-content-center align-items-center mt-4 ml-4"
        responsive
        @click="agregar()"
        ><em class="documento_svg icon-boton"></em>
      </b-button>
    </div>

    <div>
      <b-table
        :items="datosTabla"
        :fields="fields"
        :per-page="registrosPorPagina"
        :current-page="paginaActual"
        responsive
        style="margin-top: 6%"
      >
        <template v-slot:cell(ACCIONES)="row">
          <b-button-group>
            <b-button
              title="Vista previa documento"
              size="sm"
              variant="outline-primary"
              @click="vistaPrevia(row.item)"
              v-if="
                $localStorageService.can('PAS_01_portal_aut_emisi_deta') &&
                !row.item.rutaDocumentacion.includes('.zip')
              "
              ><em class="fa fa-eye"></em
            ></b-button>
            <b-button
                title="Modificar documento"
                size="sm"
                variant="outline-warning"
                @click="modificar(row.item)"
                v-if="$localStorageService.can('PAS_01_portal_aut_emisi_edit') && !row.item.rutaDocumentacion.includes('CERTIFICADO REALIZADO AL MOMENTO')"
            ><em class="fa fa-pencil"></em
            ></b-button>
            <b-button
              v-if="
                !row.item.registro &&
                $localStorageService.can('PAS_01_portal_aut_emisi_inac') &&
                !row.item.rutaDocumentacion.includes(
                  'CERTIFICADO REALIZADO AL MOMENTO'
                )
              "
              title="Activar documento"
              variant="outline-danger"
              size="sm"
              @click="activarDesactivarDocumento(row.item)"
              ><em class="fa fa-undo"></em
            ></b-button>
            <b-button
              v-else-if="
                $localStorageService.can('PAS_01_portal_aut_emisi_inac') &&
                !row.item.rutaDocumentacion.includes(
                  'CERTIFICADO REALIZADO AL MOMENTO'
                )
              "
              title="Desactiva documento"
              variant="outline-danger"
              size="sm"
              @click="activarDesactivarDocumento(row.item)"
            >
              <b-icon icon="trash-fill"></b-icon>
            </b-button>
          </b-button-group>
        </template>
      </b-table>
      <b-pagination
        v-if="datosTabla !== undefined && datosTabla.length > 10"
        align="center"
        v-model="paginaActual"
        :total-rows="datosTabla.length"
        :per-page="registrosPorPagina"
        aria-controls="my-table1"
      ></b-pagination>
    </div>
    <div
      v-if="datosTabla.length === 0"
      class="d-flex justify-content-center align-items-center"
      style="min-height: 30vh"
    >
      <p>No se encontraron resultados</p>
    </div>

    <b-modal v-model="show" :title="tituloModal" size="lg" no-close-on-backdrop>
      <b-container fluid>
        <b-row>
          <b-col>
            <label>Selecciona una empresa/broker/aseguradora:</label>
            <div>
              <v-select
                label="nombreComercial"
                :options="lstEmpresas"
                @input="seleccinarEmpresa($event)"
                v-model="$v.emisionRenovacion.empresaAltaDTO.$model"
                :state="validateState('empresaAltaDTO')"
                :class="selectClass('empresaAltaDTO')"
                style="width: 95%"
              >
                <span slot="no-options">No hay datos</span>
              </v-select>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>Elige tu cuenta:</label>
            <v-select
              label="nombreCuenta"
              :options="lstCuentas"
              v-model="$v.emisionRenovacion.cuentasDTO.$model"
              :state="validateState('cuentasDTO')"
              :class="selectClass('cuentasDTO')"
              style="width: 95%"
              @input="obtenerPlanes($event)"
            >
              <span slot="no-options">No hay datos</span>
            </v-select>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>Elige tu plan:</label>
            <v-select
              label="nombrePlan"
              :options="lslPlan"
              v-model="$v.emisionRenovacion.planDTO.$model"
              :state="validateState('planDTO')"
              :class="selectClass('planDTO')"
              style="width: 95%"
            >
              <span slot="no-options">No hay datos</span>
            </v-select>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>¿Qué deseas subir?</label>
            <v-select
              label="tipoDocumententoLegal"
              :options="lstCatSubir"
              v-model="$v.emisionRenovacion.tipoDocumentoLegalDTO.$model"
              :state="validateState('tipoDocumentoLegalDTO')"
              :class="selectClass('tipoDocumentoLegalDTO')"
              style="width: 95%"
            >
              <span slot="no-options">No hay datos</span>
            </v-select>
          </b-col>
        </b-row>
        <b-row class="mt-4 mb-2">
          <b-col></b-col>
          <b-col v-if="emisionRenovacion.idDoumentacionLegal == null && totalArchivos === 0">
            <span class="btn btn-primary btn-file">
              <span>
                <input
                  type="file"
                  multiple="multiple"
                  @change="changeArchivo($event)"
                />
                <span>Subir Archivo</span>
                <b-spinner
                  v-if="loaderArchivo"
                  small
                  variant="light"
                  label="Spinning"
                ></b-spinner>
              </span>
            </span>
          </b-col>
          <b-col v-if="emisionRenovacion.idDoumentacionLegal != null && totalArchivos === 0">
            <span class="btn btn-primary btn-file">
              <span>
                <input type="file" @change="changeArchivoModificar($event)" />
                <span>Subir Archivo</span>
                <b-spinner
                  v-if="loaderArchivo"
                  small
                  variant="light"
                  label="Spinning"
                ></b-spinner>
              </span>
            </span>
          </b-col>
          <b-col></b-col>
        </b-row>
        <b-row>
          <table
            v-if="listaArchivos.length > 0"
            class="table table-sm table-default table-bordered table-striped text-center"
          >
            <thead>
              <tr class="table-b-table-default">
                <th>Nombre del archivo</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(archivo, index) in listaArchivos"
                :key="listaArchivos.indexOf(archivo)"
              >
                <td>
                  {{ archivo.nombre }}
                </td>
                <td>
                  <b-button-group>
                    <b-button
                      v-on:click="vistaPreviaTable(archivo)"
                      size="sm"
                      variant="info"
                      v-if="!archivo.nombre.includes('.zip')"
                    >
                      <font-awesome-icon icon="eye" />
                    </b-button>
                    <b-button
                      v-on:click="eliminar(index)"
                      size="sm"
                      variant="danger"
                    >
                      <font-awesome-icon icon="times" />
                    </b-button>
                  </b-button-group>
                </td>
              </tr>
            </tbody>
          </table>
          <label>Total de Archivos: {{ totalArchivos }}</label>
        </b-row>
        <b-row v-if="mostrarVista">
          <b-col>
            <div id="loadImg" class="text-center">
              <b-spinner small variant="primary" label="Spinning"></b-spinner>
            </div>
            <iframe
              :src="'data:application/pdf;base64,' + base64Archivo"
              width="100%"
              height="600"
              onload="document.getElementById('loadImg').style.display='none';"
              style="height: 77vh"
            ></iframe>
          </b-col>
        </b-row>
      </b-container>
      <div slot="modal-footer">
        <b-button
          v-if="emisionRenovacion.idDoumentacionLegal == null"
          variant="outline-primary"
          @click="guardaEmisionRenovacion()"
          :disabled="loaderAcciones"
        >
          <span v-if="!loaderAcciones">Guardar</span>
          <span v-if="loaderAcciones">
            <b-spinner small></b-spinner>
            Cargando...
          </span>
        </b-button>
        <b-button
          v-if="emisionRenovacion.idDoumentacionLegal != null"
          variant="outline-primary"
          @click="modificarEmisionRenovacion()"
          :disabled="loaderAcciones"
        >
          <span v-if="!loaderAcciones">Guardar</span>
          <span v-if="loaderAcciones">
            <b-spinner small></b-spinner>
            Cargando...
          </span>
        </b-button>
        <b-button variant="outline-danger" @click="cerrarModal()"
          >Cancelar</b-button
        >
      </div>
    </b-modal>
    <b-modal
      v-model="showVistaPrevia"
      title="Vista Previa"
      size="lg"
      no-close-on-backdrop
    >
      <b-container fluid>
        <b-row>
          <b-col>
            <div id="loadImg" class="text-center">
              <b-spinner small variant="primary" label="Spinning"></b-spinner>
            </div>
            <iframe
              :src="'data:application/pdf;base64,' + base64Archivo"
              width="100%"
              height="600"
              onload="document.getElementById('loadImg').style.display='none';"
              style="height: 77vh"
            ></iframe>
          </b-col>
        </b-row>
      </b-container>
      <div slot="modal-footer">
        <b-button variant="outline-danger" @click="cerrarModalPrevia()"
          >Cancelar</b-button
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
export default {
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    loader: false,
    loaderArchivo: false,
    datosTabla: [],
    fields: [],
    paginaActual: 0,
    lstEmpresas: [],
    lstCuentas: [],
    lslPlan: [],
    lstCatSubir: [],
    listaArchivos: [],
    emisionRenovacion: {
      idDoumentacionLegal: null,
      empresaAltaDTO: null,
      cuentasDTO: null,
      planDTO: null,
      tipoDocumentoLegalDTO: null,
      listaArchivos: null,
      imagenBase64: null,
    },
    show: false,
    tituloModal: null,
    loaderAcciones: false,
    totalArchivos: 0,
    showVistaPrevia: false,
    base64Archivo: "",
    filtro: {
      id: null,
      palabraClave: null,
      registroActivo: null,
    },
    mostrarVista: false,
    registrosPorPagina: 10,
  }),
  validations: {
    emisionRenovacion: {
      empresaAltaDTO: { required },
      cuentasDTO: { required },
      planDTO: { required },
      tipoDocumentoLegalDTO: { required },
    },
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.obtenerListaEmpresas();
    this.obtenerTipoDocumentosLegales();
    //this.obtenerDocumentosCertificadosAcuerdoServicio();
    this.obtenerDocumentosCertificadosAcuerdoServicio();
  },
  mounted() {
    this.fields = [
      { key: "idDoumentacionLegal", label: "ID DOCUMENTO", sortable: true },
      { key: "documentacion", label: "DOCUMENTO", sortable: true },
      {
        key: "tipoDocumentoLegalDTO.tipoDocumententoLegal",
        label: "TIPO",
        sortable: true,
      },
      {
        key: "empresaAltaDTO.nombreComercial",
        label: "EMPRESA",
        sortable: true,
      },
      { key: "cuentasDTO.nombreCuenta", label: "CUENTA", sortable: true },
      { key: "planDTO.nombrePlan", label: "PLAN", sortable: true },
      "ACCIONES",
    ];
  },
  methods: {
    obtenerListaEmpresas() {
      this.$http
        .get(this.$api + "portalautoservicio/catalogo/empresas")
        .then((response) => {
          if (response.data.data) {
            let resultado = response.data.data;
            this.lstEmpresas = [];
            resultado.forEach((item, index) => {
              item.id = index;
              this.lstEmpresas.push(item);
            });
          }
        })
        .catch(function (error) {
          console.error(error);
        });
    },
    seleccinarEmpresa(evento) {
      if (evento != null) {
        this.obtenerCuentasEmpresa(evento);
      }
    },
    obtenerCuentasEmpresa(empresa) {
      this.emisionRenovacion.cuentasDTO = null;
      const params = {
        idEmpresa: empresa.idEmpresa,
      };
      this.$http
        .post(this.$api + "portalautoservicio/obtener/cuentasEmpresa", params)
        .then((response) => {
          this.loaderPlanes = false;
          if (response.data.data) {
            this.lstCuentas = [];
            this.lstCuentas = response.data.data;
          }
        })
        .catch(function (error) {
          console.error(error);
        })
        .finally(() => {});
    },
    agregar() {
      this.emisionRenovacion = {
        empresaAltaDTO: null,
        cuentasDTO: null,
        planDTO: null,
        tipoDocumentoLegalDTO: null,
        listaArchivos: null,
        imagenBase64: null,
      };
      this.tituloModal = "Agregar Documento";
      this.show = true;
      this.listaArchivos = [];
      this.totalArchivos = 0;
      this.mostrarVista = false;
    },
    cerrarModal() {
      this.show = false;
      this.emisionRenovacion = {
        empresaAltaDTO: null,
        cuentasDTO: null,
        planDTO: null,
        tipoDocumentoLegalDTO: null,
        listaArchivos: null,
        imagenBase64: null,
      };
      this.listaArchivos = [];
      this.totalArchivos = 0;
    },
    cerrarModalPrevia() {
      this.showVistaPrevia = false;
      this.emisionRenovacion = {
        empresaAltaDTO: null,
        cuentasDTO: null,
        planDTO: null,
        tipoDocumentoLegalDTO: null,
        listaArchivos: null,
        imagenBase64: null,
      };
      this.listaArchivos = [];
      this.totalArchivos = 0;
    },
    async changeArchivo(e) {
      this.loaderArchivo = true;
      let file = e.target.files || e.dataTransfer.files;
      for (let i = 0; i < file.length; i++) {
        if (file[i].name.includes(".zip") || file[i].name.includes(".pdf")) {
          const data = await this.getBase64(file[i]);
          let dataAux = data
            .replace("data:application/x-zip-compressed;base64,", "")
            .replace("data:application/pdf;base64,", "");
          this.listaArchivos.push({ base64: dataAux, nombre: file[i].name });
        } else {
          this.$swal.fire({
            icon: "info",
            title: "Aviso",
            text: "Los archivos deben ser tipo .zip o .pdf",
          });
          this.loaderArchivo = false;
          this.totalArchivos = 0;
          this.listaArchivos = [];
          e.target.value = "";
          return false;
        }
      }
      this.loaderArchivo = false;
      this.totalArchivos = this.listaArchivos.length;
      e.target.value = "";
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    changeArchivoModificar(e) {
      this.loaderArchivo = true;
      const file = e.target.files[0];
      if (file.name.includes(".zip") || file.name.includes(".pdf")) {
        this.emisionRenovacion.documentacion = file.name;
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64String = reader.result
            .replace("data:", "")
            .replace(/^.+,/, "");
          this.emisionRenovacion.imagenBase64 = base64String;
          this.loaderArchivo = false;
          e.target.value = "";
          this.listaArchivos = [];
          this.listaArchivos.push({
            base64: this.emisionRenovacion.imagenBase64,
            nombre: this.emisionRenovacion.documentacion,
          });
          this.totalArchivos = this.listaArchivos.length;
        };
        reader.readAsDataURL(file);
      } else {
        this.$swal.fire({
          icon: "info",
          title: "Aviso",
          text: "Los archivos deben ser tipo pdf",
        });
        this.loaderArchivo = false;
        e.target.value = "";
        return false;
      }
    },
    guardaEmisionRenovacion() {
      this.$v.emisionRenovacion.$touch();
      if (this.$v.emisionRenovacion.$anyError) {
        return;
      }
      if (
        !this.$v.emisionRenovacion.$invalid &&
        this.listaArchivos.length > 0
      ) {
        this.loaderAcciones = true;
        this.emisionRenovacion.listaArchivos = this.listaArchivos;
        this.$http
          .post(
            this.$api +
              "portalautoservicio/catalogo/guardarDocumentoCertificadoAcuerdoServicioV2",
            this.emisionRenovacion
          )
          .then((response) => {
            if (response.data.data) {
              this.show = false;
              this.obtenerDocumentosCertificadosAcuerdoServicio();
              this.$swal.fire({
                icon: "info",
                title: "Aviso",
                text: "Se subio el archivo correctamente ",
              });
              this.emisionRenovacion = {
                empresaAltaDTO: null,
                cuentasDTO: null,
                planDTO: null,
                tipoDocumentoLegalDTO: null,
                listaArchivos: null,
                imagenBase64: null,
                idDoumentacionLegal: null,
              };
              this.listaArchivos = [];
              this.totalArchivos = 0;
              this.mostrarVista = false;
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Aviso",
                text: "Ocurrio un error",
              });
            }
          })
          .catch(() => {
            this.$swal.fire({
              icon: "error",
              title: "Aviso",
              text: "Ocurrio un error",
            });
          })
          .finally(() => {
            this.loaderAcciones = false;
          });
      }
    },
    modificarEmisionRenovacion() {
      this.$v.emisionRenovacion.$touch();
      if (this.$v.emisionRenovacion.$anyError) {
        return;
      }
      if (
        !this.$v.emisionRenovacion.$invalid &&
        this.emisionRenovacion.imagenBase64 !== null
      ) {
        this.emisionRenovacion.listaArchivos = this.listaArchivos;
        this.loaderAcciones = true;
        this.$http
          .post(
            this.$api +
              "portalautoservicio/catalogo/guardarDocumentoCertificadoAcuerdoServicio",
            this.emisionRenovacion
          )
          .then((response) => {
            if (response.data.data) {
              this.show = false;
              this.obtenerDocumentosCertificadosAcuerdoServicio();
              this.$swal.fire({
                icon: "info",
                title: "Aviso",
                text: "Se subio el archivo correctamente ",
              });
              this.emisionRenovacion = {
                empresaAltaDTO: null,
                cuentasDTO: null,
                planDTO: null,
                tipoDocumentoLegalDTO: null,
                listaArchivos: null,
                imagenBase64: null,
                idDoumentacionLegal: null,
              };
              this.listaArchivos = [];
              this.totalArchivos = 0;
              this.mostrarVista = false;
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Aviso",
                text: "Ocurrio un error",
              });
            }
          })
          .catch(() => {
            this.$swal.fire({
              icon: "error",
              title: "Aviso",
              text: "Ocurrio un error",
            });
          })
          .finally(() => {
            this.loaderAcciones = false;
          });
      }
    },
    obtenerTipoDocumentosLegales() {
      const params = {
        idModulo: 2,
      };
      this.$http
        .post(
          this.$api + "portalautoservicio/catalogo/tipoDocumentosLegal",
          params
        )
        .then((respuesta) => {
          if (respuesta.data.data) {
            this.lstCatSubir = respuesta.data.data;
          }
        });
    },
    obtenerDocumentosCertificadosAcuerdoServicio() {
      this.datosTabla = [];
      this.loader = true;
      this.$http
        .post(
          this.$api +
            "portalautoservicio/obtener/detalleDocumentoCertificadoAcuerdoServicioV2",
          this.filtro
        )
        .then((respuesta) => {
          if (respuesta.data.data) {
            this.datosTabla = respuesta.data.data;
          }
        })
        .finally(() => {
          this.loader = false;
        });
    },
    vistaPrevia(item) {
      this.showVistaPrevia = true;
      this.base64Archivo = item.imagenBase64;
    },
    modificar(item) {
      this.mostrarVista = false;
      this.listaArchivos = [];
      this.totalArchivos = 0;
      this.emisionRenovacion = JSON.parse(JSON.stringify(item));
      this.tituloModal = "Modificar";
      this.show = true;
      this.listaArchivos.push({
        base64: item.imagenBase64,
        nombre: item.documentacion,
      });
      this.totalArchivos = this.listaArchivos.length;
    },
    vistaPreviaTable(item) {
      this.mostrarVista = true;
      this.base64Archivo = item.base64;
    },
    activarDesactivarDocumento(item) {
      const mensaje = item.registro
        ? "¿Está seguro de desactivar el documento?"
        : "¿Está seguro de activar el documento?";
      this.$swal({
        icon: "warning",
        text: mensaje,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCancelButton: true,
        showConfirmButton: true,
      }).then((aceptar) => {
        if (aceptar.value) {
          this.$http
            .delete(
              this.$api +
                "portalautoservicio/desctivarActivar/detalleDocumentoCertificadosAcuerdos?idDocumento=" +
                item.idDoumentacionLegal
            )
            .then((respuesta) => {
              if (respuesta.data.data) {
                item.registro = !item.registro;
                this.$swal.fire({
                  icon: "info",
                  title: "Aviso",
                  text: "El documento se actualizó correctamente",
                });
              }
            });
        }
      });
    },
    eliminar(i) {
      this.listaArchivos.splice(i, 1);
      this.totalArchivos = this.listaArchivos.length;
      this.mostrarVista = false;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.emisionRenovacion[name];
      return $dirty ? !$error : null;
    },
    selectClass(attribute) {
      let state = this.validateState(attribute);
      if (state) {
        return "border rounded-lg border-success";
      } else if (state === false) {
        return "border rounded-lg border-danger";
      } else {
        return "";
      }
    },
    obtenerPlanes(cuenta) {
      this.emisionRenovacion.planDTO = null;
      let body = {
        idCuenta: cuenta.idCuenta,
      };
      this.$http
        .post(this.$api + "portalautoservicio/catalogo/planes", body)
        .then((response) => {
          if (response.data.data) {
            this.lslPlan = [];
            this.lslPlan = response.data.data;
          }
        })
        .catch(function (error) {
          console.error(error);
        })
        .finally(() => {});
    },
  },
};
</script>

<style scoped>
.btn-file {
  position: relative;
  overflow: hidden;
}
.btn-file input[type="file"] {
  position: absolute;
  top: 0;
  right: 0;
  min-width: 100%;
  min-height: 100%;
  font-size: 100px;
  text-align: right;
  filter: alpha(opacity=0);
  opacity: 0;
  outline: none;
  background: white;
  cursor: inherit;
  display: block;
}
.card-body {
  padding: 0.25rem !important;
}
.card-footer {
  font-size: 12px;
  font-weight: bold;
}
.barras {
    border-width: 1px;
    border-style: solid;
    border-color: #C6E9EE;
    background: #ffffff;
    margin-top: 20px;
    padding-right: 1%;
    padding-left: 1%;
    border-radius: 50px;
    text-align: left;
    align-items: center;
}
.botonesAzulFuerteRedondo{
  height: 2em;
  width: 2em;
  border-radius: 50px;
  background-color: #1B81AF;
  border: 1px solid #1B81AF;
}

.botonesAzulFuerteRedondo:hover{
  height: 2em;
  width: 2em;
  border-radius: 50px;
  background-color: #69b8dd;
  border: 1px solid #69b8dd;
}
.btn_busqueda{
  height: 1.7em;
  width: 1.7em;
}
</style>
